import LlCardLocaleText from "../ll-card-locale-text.marko";
import LlFavoriteHeart from "../ll-favorite-heart.marko";

<div
  class="card card--adventure ll-card-shell"
  data-card-slug=input.item.slug
  data-content-id=(input.item.contentId || input.item.slug)
  data-stats=(input.item.stats ? JSON.stringify(input.item.stats) : null)
  data-card-level=(input.item.level || '').toLowerCase()
>
  <a href=`${input.basePath}/${input.item.slug}` class="card__link" style="text-decoration:none">
    <div class="card__image-wrap">
      <if=input.item.coverImage>
        <img
          src=input.item.coverImage
          alt=(input.item.targetTitle || input.item.title)
          class="card__image"
          width="840"
          height="360"
          loading="lazy"
          decoding="async"
          onError="this.style.display='none';this.parentElement.innerHTML='<div class=card__image-placeholder>🗺️</div>'"
        >
      </if>
      <else>
        <div class="card__image-placeholder">🗺️</div>
      </else>
    </div>
    <div class="card__body">
      <div class="card__meta">
        <div class="ll-card-level-stripe-host" data-level-stripe tabindex="-1" aria-hidden="true"></div>
      </div>
      <if=(input.item.learnerTitle || input.item.translatedTitle)>
        <p class="title-aid">
          <LlCardLocaleText
            text=(input.item.learnerTitle || input.item.translatedTitle)
            item=input.item
            slot="titleAid"
            sectionKey=(input.sectionKey || "adventures")
            uiLang=$global.uiLang
            targetCode=$global.targetCode
          />
        </p>
        <h2 class="card__title">
          <span data-ll-card-title-slot>
            <LlCardLocaleText
              text=(input.item.targetTitle || input.item.title)
              item=input.item
              slot="title"
              sectionKey=(input.sectionKey || "adventures")
              uiLang=$global.uiLang
              targetCode=$global.targetCode
            />
          </span>
        </h2>
      </if>
      <else>
        <h2 class="card__title">
          <span data-ll-card-title-slot>
            <LlCardLocaleText
              text=(input.item.targetTitle || input.item.title)
              item=input.item
              slot="title"
              sectionKey=(input.sectionKey || "adventures")
              uiLang=$global.uiLang
              targetCode=$global.targetCode
            />
          </span>
        </h2>
      </else>
      <p class="card__teaser">
        <span data-ll-card-teaser-slot>
          <LlCardLocaleText
            text=(input.item.interfaceTeaser || input.item.translatedTeaser || input.item.teaser || input.item.interfaceDescription || input.item.translatedDescription || input.item.description || "")
            item=input.item
            slot="teaser"
            sectionKey=(input.sectionKey || "adventures")
            uiLang=$global.uiLang
            targetCode=$global.targetCode
          />
        </span>
      </p>
      <div class="ll-card-stripe ll-card-stripe--bottom" data-stripe-bottom aria-hidden="true"></div>
    </div>
  </a>
  <LlFavoriteHeart contentId=(input.item.contentId || input.item.slug)/>
</div>
